var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcViewChatDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "14px",
    viewBox: "0 0 23 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icViewChatDesktop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DESKTOP-CHAT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chat-group-expanded-video-copy-2",
    transform: "translate(-956.000000, -39.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(821.000000, -70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(126.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5,9 C24.894395,9 28.879462,11.3947645 31.8200368,15.2891858 C32.0599877,15.6078629 32.0599877,16.0530735 31.8200368,16.3717506 C28.879462,20.2614855 24.894395,22.65625 20.5,22.65625 C16.105605,22.65625 12.120538,20.2614855 9.17996318,16.3670642 C8.94001227,16.0483871 8.94001227,15.6031765 9.17996318,15.2844994 C12.120538,11.3947645 16.105605,9 20.5,9 Z M20.4450881,20.4904838 C22.7671876,20.3405249 24.6530413,18.454678 24.8030008,16.132587 C24.9802256,13.310633 22.6535819,10.988542 19.8361619,11.1657662 C17.5095182,11.3111809 15.6236645,13.1970278 15.4782492,15.523663 C15.3010244,18.345617 17.6276681,20.667708 20.4450881,20.4904838 Z M20.3019033,18.3386235 C18.7845247,18.4340452 17.530643,17.1844758 17.6305901,15.6668169 C17.7078219,14.4127037 18.725465,13.3994165 19.9793467,13.3176265 C21.4967253,13.2222048 22.750607,14.4717742 22.6506599,15.9894331 C22.568885,17.2480902 21.5512419,18.2613774 20.3019033,18.3386235 Z",
    id: "icViewChatDesktop"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcViewChatDesktop);
export default __webpack_public_path__ + "static/media/icViewChatDesktop.ac513efcfc17cd28b1362c6555550c99.svg";
export { ForwardRef as ReactComponent };